<script lang="ts">
	import { _ } from "svelte-i18n";
	import { FormGroup, Input, Label } from "@sveltestrap/sveltestrap";
	import GenerateTopicButton from "./GenerateTopicButton.svelte";
	import UseSuggestionButton from "./UseSuggestionButton.svelte";

	let {
		value = $bindable(""),
		disabled = false,
	}: {
		value?: string;
		disabled?: boolean;
	} = $props();

	function onTopic(topic: string) {
		value = topic;
	}
</script>

<FormGroup>
	<Label for="v2-topic">{$_("landingpage.newPresentation.topic")}</Label>
	<Input
		type="text"
		id="v2-topic"
		name="v2-topic"
		bind:value
		required
		maxlength={150}
		autocomplete="off"
		{disabled}
	/>
	<div class="topic-actions mt-2 d-flex gap-2">
		<GenerateTopicButton {onTopic} />
		<UseSuggestionButton {onTopic} />
	</div>
</FormGroup>
